import { Id, AgreementServiceHub } from 'src/types'

import Api, { make, Response } from '.'

type ResponseServiceHubs = {
  service_hubs: AgreementServiceHub[]
}

export function getServiceHubs(
  organization_id: Id
): Promise<Response<ResponseServiceHubs>> {
  return make<ResponseServiceHubs>({
    axiosCall: Api.get(`/organizations/${organization_id}/service_hubs`)
  })
}
